<template>
    <div>
        <DialogoFotos ref="dialFotos" :titulo="titulo" :tipo="tipo" :width="500" />
        <DialogoConyuge ref="refDialogConyu" :titulo="titulo" @cerrarDialogoCony="deleteData"
            :tipoEstadoCivil="tipoEstadoCivil" />
        <ValidationObserver ref="obs" v-slot="{ invalid, state }">
            <v-form name="FormPreAfi" @submit.prevent="submit">
                <v-card class="custom-card" flat>
                    <v-row class="mx-1">
                        <v-col cols="12" md="12">
                            <div class="font-weight-bold text-body-1 black--text">
                                MIS DATOS PERSONALES
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="text-center">
                        <v-col cols="12" md="3" class="d-flex justify-center">
                            <v-col cols="12" md="12">
                                <div class="font-weight-bold primary--text text--lighten-1 text-body-1 mb-2"
                                    ref="fotoLegajo">
                                    FOTO DE LEGAJO
                                </div>
                                <v-avatar size="180" tile style="position: relative;" class="elevation-1"
                                    :class="{ 'error-avatar': !fotoCarnet && errors.length }">
                                    <v-img v-if="fotoCarnet" :src="`data:image/png;base64,${fotoCarnet}`"></v-img>
                                    <v-img v-else src="@/assets/blank-user-profile.png"></v-img>
                                    <v-btn small color="primary" class="py-5 px-8" @click="lanzarDialogo"
                                        style="position: absolute; top: 78%;">
                                        <v-icon dark class="mr-3">mdi-camera-plus-outline</v-icon>
                                        agregar foto
                                    </v-btn>
                                </v-avatar>
                                <v-alert v-if="!fotoCarnet && errors.length" type="error" color="orange darken-2" dense
                                    class="mt-2 rounded-0">
                                    {{ errors[0] }}
                                </v-alert>
                            </v-col>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-row class="mt-4">
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces"
                                        v-slot="{ errors, dirty }">
                                        <v-text-field dense v-model="nuevoAfi.nombres" label="Nombres"
                                            :error-messages="errors"
                                            @input="nuevoAfi.nombres = nuevoAfi.nombres.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|minmax:2,50|alpha_spaces"
                                        v-slot="{ errors, dirty }">
                                        <v-text-field dense v-model="nuevoAfi.apellido" label="Apellido"
                                            :error-messages="errors"
                                            @input="nuevoAfi.apellido = nuevoAfi.apellido.toUpperCase()">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required|length:8|numeric" v-slot="{ errors, dirty }">
                                        <v-text-field dense v-model="nuevoAfi.nrodoc" type="number" hide-spin-buttons
                                            @input="nuevoAfi.nrodoc = nuevoAfi.nrodoc" label="DNI Nro." readonly
                                            :error-messages="errors" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-select dense v-model="nuevoAfi.sexo" :items="itemSexo" label="Sexo"
                                            :error-messages="errors">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <ValidationProvider
                                        :rules="{ required: true, numeric: true, length: 11, validCuil: { dni: nuevoAfi.nrodoc } }"
                                        v-slot="{ errors, dirty }">
                                        <v-text-field dense v-model="nuevoAfi.cuil" type="number" hide-spin-buttons
                                            label="CUIL" :error-messages="errors" @keydown="preventArrowKeys">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="2">
                                    <ValidationProvider rules="required|max:10|menoranios" v-slot="{ errors, dirty }">
                                        <v-text-field v-model="nuevoAfi.fecnacim" dense label="Fecha de nacimiento:"
                                            value="01/01/1900" type="date" :error-messages="errors"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-autocomplete dense v-model="nuevoAfi.nacionalidad" :items="nacionalidades"
                                            item-value="id" item-text="desnacionalidad" label="Nacionalidad"
                                            @input="selectNacionalidad" return-object :error-messages="errors">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-autocomplete dense v-model="nuevoAfi.tiponacionalidad"
                                            :error-messages="errors" :items="tipoNacionalidad" item-value="tna_id"
                                            item-text="tna_destipnac" label="Tipo de nacionalidad" return-object
                                            @input="selectTipNacionalidad">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" :md="ocultarFecha ? 12 : 6">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-autocomplete dense v-model="nuevoAfi.estadocivil" :error-messages="errors"
                                            :items="estadoCivilFilter" item-value="id" item-text="desestadocivil"
                                            label="Estado Civil" return-object @input="selectEstadoCivil"
                                            @change="onChangeEstadoCivil">
                                        </v-autocomplete>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" v-if="!ocultarFecha">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-text-field v-model="nuevoAfi.fecestadocivil" dense
                                            label="Fecha de estado civil:" type="date" data-skip-on-tab="true"
                                            :error-messages="errors"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12"
                                    :md="(nuevoAfi.discapacidad == 'N' || nuevoAfi.discapacidad == '') ? '12' : '6'">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-select v-model="nuevoAfi.discapacidad" :items="discapacidadOptions"
                                            @change="changeDiscapacidad" item-text="text" item-value="value"
                                            label="Discapacitado" :error-messages="errors" dense></v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" v-if="(nuevoAfi.discapacidad == 'S')">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <v-select v-model="nuevoAfi.tramita_discapacidad" :items="discapacidadOptions"
                                            item-text="text" item-value="value" :error-messages="errors"
                                            label="Tramitar régimen especial para discapacitados" dense></v-select>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        :rules="{ required: (dataPadre.apellido !== '') ? true : false, alpha_spaces: true }"
                                        v-slot="{ errors, dirty }">
                                        <v-text-field v-model="dataPadre.nombres" :error-messages="errors"
                                            @input="dataPadre.nombres = dataPadre.nombres.toUpperCase()" dense
                                            label="Nombre Padre">
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        :rules="{ required: (dataPadre.nombres !== '') ? true : false, alpha_spaces: true }"
                                        v-slot="{ errors, dirty }">
                                        <v-text-field v-model="dataPadre.apellido" :error-messages="errors"
                                            @input="dataPadre.apellido = dataPadre.apellido.toUpperCase()" dense
                                            label="Apellido Padre"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        :rules="{ required: (dataMadre.apellido !== '') ? true : false, alpha_spaces: true }"
                                        v-slot="{ errors }">
                                        <v-text-field v-model="dataMadre.nombres" :error-messages="errors"
                                            @input="dataMadre.nombres = dataMadre.nombres.toUpperCase()" dense
                                            label="Nombre Madre"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider
                                        :rules="{ required: (dataMadre.nombres !== '') ? true : false, alpha_spaces: true }"
                                        v-slot="{ errors }">
                                        <v-text-field v-model="dataMadre.apellido" :error-messages="errors"
                                            @input="dataMadre.apellido = dataMadre.apellido.toUpperCase()" dense
                                            label="Apellido Madre"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <!--                                 <v-col cols="12" md="6" v-if="(hijos == 'SI')">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <v-select v-model="cantidadHijos" :items="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
                                            @input="onChangeHijos" label="Cantidad de hijos" dense
                                            :error-messages="errors"></v-select>
                                    </ValidationProvider>
                                </v-col> -->
                                <v-col cols="12" :md="(hijos == 'SI') ? '6' : '12'">
                                    <ValidationProvider rules="required" v-slot="{ errors, dirty }">
                                        <v-select v-model="hijos" label="Hijos" :items="['SI', 'NO']" dense
                                            :error-messages="errors">
                                        </v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6" v-if="(hijos == 'SI')">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <v-select v-model="cantidadHijos" :items="[1, 2, 3, 4, 5, 6, 7, 8, 9]"
                                            @input="onChangeHijos" label="Cantidad de hijos" dense
                                            :error-messages="errors"></v-select>
                                    </ValidationProvider>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <v-row>
                        <v-card-text class="font-weight-bold text-body-1 black--text ">
                            DOCUMENTACIÓN REQUERIDA:
                        </v-card-text>
                    </v-row>
                    <v-row class="d-flex justify-space-around align-end">
                        <InputButtonArchivo @fileSelected="handleFileSelected" op="dniFrentePreAfiliado"
                            label="DNI FRENTE" :subtitle="nuevoAfi.nombres + ' ' + nuevoAfi.apellido" />
                        <InputButtonArchivo @fileSelected="handleFileSelected" op="dniDorsoPreAfiliado"
                            label="DNI DORSO" :subtitle="nuevoAfi.nombres + ' ' + nuevoAfi.apellido" />
                        <InputButtonArchivo v-if="(nuevoAfi.discapacidad == 'S')" @fileSelected="handleFileSelected"
                            op="certDisc" label="CUD" subtitle="CERT DE DISCAPACIDAD" />
                    </v-row>
                    <div class="form-footer" @click="forzarValidacion">
                        <v-spacer></v-spacer>
                        <!-- disabled="invalid || !formValid || !hayFotoCarnetCargada" -->
                        <v-btn :disabled="invalid || !hayFotoCarnetCargada || !formValid" color="primary" elevation="0"
                            type="submit" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </div>
                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import DialogoCard from '@/components/dialogos/DialogoCard.vue';
import DialogoFotos from '@/components/dialogos/DialogoFotos.vue';
import DialogoEditar from '@/components/dialogos/DialogoEditar.vue';
import DialogoConyuge from '@/components/dialogos/DialogoConyuge.vue';
import Alertas from '@/components/alerts/Alertas.vue';
import InputFechaModal from '@/components/inputs/InputFechaModal.vue';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';

import { mapActions, mapGetters } from 'vuex';

export default {
    name: "form-pre-afi",
    components:
    {
        ValidationProvider,
        ValidationObserver,
        Alertas,
        DialogoFotos,
        InputFechaModal,
        DialogoCard,
        DialogoEditar,
        DialogoConyuge,
        //DialogoFotos,
        InputButtonArchivo,
    },
    beforeMount() {
    },
    mounted() {
        this.nuevoAfi.nrodoc = this.datosPersonales.nrodoc
        // Scroll automático al hacer foco en cualquier input del formulario
        this.$nextTick(() => {
            const form = this.$el.querySelector('form');
            if (form) {
                form.addEventListener('focus', this.handleFieldFocus, true);
            }
        });
    },
    beforeDestroy() {
        // Limpia el event listener al destruir el componente
        const form = this.$el.querySelector('form');
        if (form) {
            form.removeEventListener('focus', this.handleFieldFocus, true);
        }
    },

    data() {
        return {
            nuevoAfi: {
                nroafi: '',
                nombres: '',
                apellido: '',
                tipdoc: 'DNI',
                nrodoc: '',
                cuil: '',
                sexo: '',
                fecnacim: '',
                fecestadocivil: '',
                nacionalidad: 1,
                desnacionalidad: '',
                estadocivil: '',
                tiponacionalidad: 1,
                desestadocivil: '',
                destipnacionalidad: '',
                fotocarnet: '',
                fecdiscapacidad: '',
                discapacidad: '',
                tramita_discapacidad: ''
            },

            //data DialogoFotos
            titulo: '',
            tipo: '',

            hijos: '',
            cantidadHijos: '',
            incrementInterval: null,
            decrementInterval: null,

            tipoEstadoCivil: '',
            hayFoto: false,
            necesitaDatos: false,
            //data common            
            //itemTipDni: ['DNI', 'CI', 'LE', 'LC', 'PAS'], // item select tipo de dni
            itemSexo: ['F', 'M', 'X'], // item select sexo
            // cuando el form es correcto
            formValid: false,
            errors: [],

            discapacidadOptions: [
                { text: 'SI', value: 'S' },
                { text: 'NO', value: 'N' },
            ],

            dataMadre: {
                nombres: '',
                apellido: '',
                tipdoc: 'DNI',
                nrodoc: '',
                sexo: '',
                fecnacim: '',
                fecestadocivil: '',
                estadocivil: 2,
                nacionalidad: 1,
                desnacionalidad: '',
                tipnacionalidad: 1,
                destipnacionalidad: '',
                tipfamiliar: 5,
                destipfamiliar: 'MADRE',
                fecfallecido: '',
                fallecido: '',
                discapacidad: 'N',
            },
            dataPadre: {
                nombres: '',
                apellido: '',
                tipdoc: 'DNI',
                nrodoc: '',
                sexo: '',
                fecnacim: '',
                fecestadocivil: '',
                estadocivil: 2,
                nacionalidad: 1,
                desnacionalidad: '',
                tipnacionalidad: 1,
                destipnacionalidad: '',
                tipfamiliar: 4,
                destipfamiliar: 'PADRE',
                fecfallecido: '',
                fallecido: '',
                discapacidad: 'N',
            },
        }
    },
    watch: {
        hijos(newValue) {
            if (newValue == 'NO') {
                this.cantidadHijos = ''
                this.onChangeHijos(this.cantidadHijos)
            }
        },

        "nuevoAfi.estadocivil"(newValue) {
            this.nuevoAfi.desestadocivil = this.estadoCivil().find(item => item.id == newValue)
        },
        "nuevoAfi.desnationalidad"(newValue) {
            this.nuevoAfi.nacionalidad = this.nacionalidades().find(item => item.desnacionalidad == newValue)
        },
    },
    computed: {
        ...mapGetters('preafiliacion', ['matricula', 'nuevoAfiliado', 'certDisc', 'dniFrentePreAfiliado', 'dniDorsoPreAfiliado', 'datosPersonales', 'fotoCarnet', 'hayFotoCarnetCargada']),
        ...mapGetters('common', ['nacionalidades', 'estadoCivil', 'tipoNacionalidad', 'tipoDoc']),
        onChangeHijos() {
            this.guardarCantHijos(this.cantidadHijos)
        },
        estadoCivilFilter() {
            return this.estadoCivil.filter(item => item.id !== 3)
        },

        ocultarFecha() {
            return (this.nuevoAfi.estadocivil == '') || (this.nuevoAfi.estadocivil == 1) || (this.nuevoAfi.estadocivil == 5) || (this.nuevoAfi.estadocivil == 7)
                || (this.nuevoAfi.estadocivil == 10)
        },
        noCargaConyuge() {
            return (this.nuevoAfi.estadocivil == 1) || (this.nuevoAfi.estadocivil == 10) || (this.nuevoAfi.estadocivil == 5) || (this.nuevoAfi.estadocivil == 7)
        },

        estadocivil() {
            return this.estadoCivil.filter(item => item.id !== 3)
        },
    },
    methods: {
        ...mapActions('preafiliacion', ['guardarDatosPersonales', 'guardarFechaNacim', 'armarNuevoAfiliado', 'addFilesPre', 'guardarDatosPadres', 'guardarCantHijos']),

        lanzarDialogo() {
            this.titulo = "Foto de legajo"
            this.tipo = "fotocarnet"
            this.$refs.dialFotos.abrirDialogo()
        },
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                this.onBlur();
            });
        },
        changeDiscapacidad(value) {
            if (value == 'N') {
                this.addFilesPre({ file: '', op: 'certDisc' })
                this.nuevoAfi.tramita_discapacidad = ''
            }
            this.handleFileSelected()
        },

        onBlur() {
            if (!this.fotoCarnet) {
                this.errors = ['Debes agregar una foto.']
                this.$refs.fotoLegajo.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            else this.errors = [];
        },
        isFormDirty(state) {
            // Verifica si al menos un campo en el estado tiene `dirty: true`
            return Object.values(state).some(field => field.dirty);
        },
        handleFileSelected() {
            if (this.nuevoAfi.discapacidad == "S") {
                ((this.dniDorsoPreAfiliado.length !== 0) && (this.dniFrentePreAfiliado.length !== 0) && (this.certDisc.length !== 0)) ? this.formValid = true : this.formValid = false
            } else {
                ((this.dniDorsoPreAfiliado.length !== 0) && (this.dniFrentePreAfiliado.length !== 0)) ? this.formValid = true : this.formValid = false
            }
        },
        onChangeEstadoCivil() {
            this.nuevoAfi.fecestadocivil = ''
        },
        submit() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.nuevoAfi.nroafi = parseInt(this.matricula)
                    this.guardarDatosPersonales(this.nuevoAfi)
                    const hasParentData = [this.dataPadre.nombres, this.dataPadre.apellido, this.dataMadre.nombres, this.dataMadre.apellido].some(value => value !== '')
                    if (hasParentData) this.guardarDatosPadres({ padre: this.dataPadre, madre: this.dataMadre })
                    this.$emit('siguiente')
                } else {
                    this.showSnack({
                        type: '400',
                        message: 'Formulario invalido, revise los campos.'
                    })
                }
            });
        },
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40)
                event.preventDefault();
        },
        /* cargarPareja(value) {
            // Despliega dialogo para permitir cargar los datos de la pareja.
            if ((value.id == 2) || (value.id == 6) || (value.id == 7) || (value.id == 8)) {
                this.tipoEstadoCivil = value.id
                //this.$refs.refDialogConyu.abrirDialog()
            }
            this.selectEstCivil(value)
        }, */
        selectNacionalidad(value) {
            this.nuevoAfi.nacionalidad = value.id
            this.nuevoAfi.desnacionalidad = value.desnacionalidad
        },
        selectTipNacionalidad(value) {
            this.nuevoAfi.tiponacionalidad = value.tna_codtipnac
            this.nuevoAfi.destipnacionalidad = value.tna_destipnac
        },
        selectEstadoCivil(value) {
            this.nuevoAfi.estadocivil = value.id
            this.nuevoAfi.desestadocivil = value.desestadocivil
        },
        deleteData() {
            this.nuevoAfi.estadocivil = ''
            this.nuevoAfi.desestadocivil = ''
        },
        actualizarFechas(fecha, tipo) {
            switch (tipo) {
                case 'fecnacim':
                    this.nuevoAfi.fecnacim = fecha
                    this.guardarFechaNacim(fecha)
                    break;
                case 'fecestadocivil':
                    this.nuevoAfi.fecestadocivil = fecha;
                    break;
            }
        },
        editarData() {
            this.overlay = false
        },


        handleFieldFocus(event) {
            // Solo scrollea cuando el foco cae sobre un campo editable (TAB entre
            // inputs). Botones u otros focuseables se excluyen para no mover la
            // pantalla cuando el usuario solo está tocando un control.
            const tag = event.target && event.target.tagName && event.target.tagName.toLowerCase()
            if (['input', 'textarea', 'select'].includes(tag)) {
                event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        },
    },
    props: { loading: Boolean, index: Number }
}

</script>

<style scoped>
.btn-fade-in-out {
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
}

.btn-fade-in-out:hover {
    opacity: 1;
}

.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}

.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #333;
    color: white;
    padding: 20px;
    text-align: center;
}

.form-content {
    padding-bottom: 110px;
    margin-bottom: 110px;
    /* Adjust as needed to avoid overlap with fixed footer */
}

.error-avatar {
    border: 2px solid red;
}
</style>